import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("div", { staticClass: "text-h6 text--text mb-4" }, [
        _vm._v(
          "\n    " + _vm._s(_setup.t("Специальность", _setup.options)) + "\n  "
        ),
      ]),
      _vm._v(" "),
      _c(
        VRadioGroup,
        {
          ref: "doctorSpecialitiesRef",
          staticClass: "doctor-specialities",
          attrs: {
            value: _setup.doctorDataStore.radioGroupValue,
            "data-qa": "doctor_specialities",
            "hide-details": "",
          },
          on: {
            change: _setup.doctorDataStore.setStateSelectedDoctorSpecialityId,
          },
        },
        [
          _c(
            VExpandTransition,
            [
              _setup.doctorDataStore.isErrorStateSpeciality &&
              !_setup.doctorDataStore.radioGroupValue
                ? _c(_setup.BaseAlert, {
                    staticClass: "mb-5",
                    attrs: {
                      color: "text-error",
                      "data-qa": "doctor_specialities_alert",
                      text: _setup.t("Выберите специальность", _setup.options),
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_setup.formattedWorkplaceList, function (workplace, index) {
            return _c(
              "label",
              {
                key: workplace.speciality.id,
                staticClass: "doctor-specialities__speciality",
                class: { "mt-5": index !== 0 },
                attrs: { "data-qa": "doctor_speciaility" },
              },
              [
                _c(VRadio, {
                  attrs: {
                    ripple: false,
                    disabled: workplace.isDisabledWorkplace,
                    value: workplace.speciality.id,
                    color: "primary",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "label",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              {
                                staticClass: "text-body-1 text--text mr-auto",
                                class: {
                                  "bg-gray-80--text":
                                    workplace.isDisabledWorkplace,
                                  "error--text ":
                                    !workplace.isDisabledWorkplace &&
                                    !_setup.doctorDataStore.radioGroupValue &&
                                    _setup.doctorDataStore
                                      .isErrorStateSpeciality,
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    attrs: {
                                      "data-qa": "doctor_speciaility_name",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(workplace.speciality.name) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                workplace.specialityAges
                                  ? _c(
                                      "span",
                                      {
                                        attrs: {
                                          "data-qa": "doctor_speciaility_ages",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(workplace.specialityAges) +
                                            "\n            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                }),
              ],
              1
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }